module.exports = __webpack_public_path__ + "assets/img/f28c-bv.svg";